// ----------------------------------------------------------------------

import { list } from 'src/theme/overrides/components/list';

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  CLINIC_DASHBOARD: '/clinic-dashboard',
  DOCTOR_DASHBOARD: '/doctor-dashboard',
  HOME: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  home: {
    root: ROOTS.HOME,
  },
  auth: {
    jwt: {
      login_select: `${ROOTS.AUTH}/jwt/login-select`,
      clinic_login: `${ROOTS.AUTH}/jwt/clinic-login`,
      doctor_login: `${ROOTS.AUTH}/jwt/doctor-login`,
      admin_login: `${ROOTS.AUTH}/jwt/admin-login`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    home: `${ROOTS.DASHBOARD}/home`,
    clinic_list: `${ROOTS.DASHBOARD}/clinic-list`,
    doctor_list: `${ROOTS.DASHBOARD}/doctor-list`,
    staff_list: `${ROOTS.DASHBOARD}/staff-list`,
    staff: {
      list: `${ROOTS.DASHBOARD}/staff-list?page=0&limit=10`,
      add: `${ROOTS.DASHBOARD}/staff-add`,
    },
    clinic: {
      list: `${ROOTS.DASHBOARD}/clinic-list`,
      add: `${ROOTS.DASHBOARD}/clinic-add`,
      details: `${ROOTS.DASHBOARD}/clinic/:id`,
    },
    doctors: {
      list: `${ROOTS.DASHBOARD}/doctors-list`,
    },
    procedures: {
      list: `${ROOTS.DASHBOARD}/procedures-list`,
      add: `${ROOTS.DASHBOARD}/procedures/add`,
      edit: `${ROOTS.DASHBOARD}/procedures/:procedureId/edit`,
    },
    enquiry: {
      list: `${ROOTS.DASHBOARD}/enquiry-list`,
      view: `${ROOTS.DASHBOARD}/enquires/:enquiryId`,
    },
    treatments: {
      list: `${ROOTS.DASHBOARD}/treatments-list`,
    },
    communities: {
      list: `${ROOTS.DASHBOARD}/communities-list`,
      view: `${ROOTS.DASHBOARD}/communities/:communityId`,
      posts: `${ROOTS.DASHBOARD}/community/:communityId/posts`,
      create_post: `${ROOTS.DASHBOARD}/community/:communityId/posts/create`,
      view_post: `${ROOTS.DASHBOARD}/community/:communityId/posts/:postId`,
      comments: `${ROOTS.DASHBOARD}/community/:communityId/posts/:postId/comments`,
    },
    concerns: {
      list:`${ROOTS.DASHBOARD}/concerns-list`
    }
  },
  // CLINIC DASHBOARD
  clinic_dashboard: {
    root: ROOTS.CLINIC_DASHBOARD,
    home: `${ROOTS.CLINIC_DASHBOARD}/home`,
    business_profile: `${ROOTS.CLINIC_DASHBOARD}/business-profile`,
    edit_business_profile: `${ROOTS.CLINIC_DASHBOARD}/business-profile/edit`,
    packages: `${ROOTS.CLINIC_DASHBOARD}/packages`,
    add_package: `${ROOTS.CLINIC_DASHBOARD}/packages/add`,
    edit_package: `${ROOTS.CLINIC_DASHBOARD}/packages/:packageId/edit`,
    products: `${ROOTS.CLINIC_DASHBOARD}/products`,
    add_product: `${ROOTS.CLINIC_DASHBOARD}/products/add`,
    edit_product: `${ROOTS.CLINIC_DASHBOARD}/products/:productId/edit`,
    doctors: `${ROOTS.CLINIC_DASHBOARD}/doctors`,
    add_doctors: `${ROOTS.CLINIC_DASHBOARD}/doctors/add?user_id=user_id_value`,
    enquires: `${ROOTS.CLINIC_DASHBOARD}/enquires`,
    enquriy_details: `${ROOTS.CLINIC_DASHBOARD}/enquires/:enquiryId`,
    telehealth: `${ROOTS.CLINIC_DASHBOARD}/telehealths`,
    add_telehealth: `${ROOTS.CLINIC_DASHBOARD}/telehealths/add`,
    edit_telehealth: `${ROOTS.CLINIC_DASHBOARD}/telehealths/:therapyId/edit`,
    telepackages: `${ROOTS.CLINIC_DASHBOARD}/telepackages`,
    add_telepackages: `${ROOTS.CLINIC_DASHBOARD}/telepackages/add`,
    edit_telepackages: `${ROOTS.CLINIC_DASHBOARD}/telepackages/:telepackagesId/edit`,
  },
  // DOCTOR DASHBOARD
  doctor_dashboard: {
    root: ROOTS.DOCTOR_DASHBOARD,
    home: `${ROOTS.DOCTOR_DASHBOARD}/home`,
    profile: `${ROOTS.DOCTOR_DASHBOARD}/profile`,
    edit_profile: `${ROOTS.DOCTOR_DASHBOARD}/profile/edit`,
    responses: `${ROOTS.DOCTOR_DASHBOARD}/userResponses`,
    edit_responses: `${ROOTS.DOCTOR_DASHBOARD}/userResponses/:userResponseId/edit`,
  },
};
